import { render } from "./GrowthChart.vue?vue&type=template&id=c492f650&scoped=true"
import script from "./GrowthChart.vue?vue&type=script&lang=js"
export * from "./GrowthChart.vue?vue&type=script&lang=js"

import "./GrowthChart.vue?vue&type=style&index=0&id=c492f650&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c492f650"]])

export default __exports__